import styled from 'styled-components';
import {
  CommercialSubCategory,
  EtcSubCategory,
  FilterType,
  ItemStatusList,
  PTypeItemStatusList,
  LandSubCategory,
  PTypeCommercialCategory,
  PTypeComplexCategory,
  PTypeIndustrialCategory,
  PTypeLandCategoty,
  PTypeResidentialCategory,
  ResidentialSubCategory,
} from '../FilterData';
import { useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
  SelectedChip,
  SelectedChipBox,
} from './OptionModal.styles';

const ACategoryGroups = [
  { label: '주거용', options: ResidentialSubCategory },
  { label: '상업/산업용', options: CommercialSubCategory },
  { label: '토지', options: LandSubCategory },
  { label: '기타', options: EtcSubCategory },
];

const PCategoryGroups = [
  { label: '토지', options: PTypeLandCategoty },
  {
    label: '주거용 건물',
    options: PTypeResidentialCategory,
  },
  { label: '상가용및업무용', options: PTypeCommercialCategory },
  { label: '산업용및기타특수용건물', options: PTypeIndustrialCategory },
  { label: '용도복합용건물', options: PTypeComplexCategory },
];

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

/**
 * 물건 종류
 */
function TotalCategoryOption({ onClose, filters, setFilters }: Props) {
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>(
    filters.itemStatus,
  );

  const categoryGroups =
    filters.type === 'a' ? ACategoryGroups : PCategoryGroups;

  const toggleGroup = (label: string) => {
    setExpandedGroups((prev) =>
      prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label],
    );
  };

  const toggleItem = (value: string) => {
    setSelectedItems((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => {
    setSelectedItems([]);
  };

  const handleSubmit = () => {
    onClose();
    setFilters({
      ...filters,
      itemStatus: selectedItems,
    });
  };

  const allOptions = (filters.type === 'a' ? ItemStatusList: PTypeItemStatusList).filter(
    (group) => group.label !== '전체',
  ).flatMap((group) => group.options.map((opt) => opt.value));
  const isSelectedAllOptions = allOptions.every((value) =>
    selectedItems.includes(value),
  );

  const toggleAll = () => {
    if (isSelectedAllOptions) {
      setSelectedItems([]);
    } else {
      setSelectedItems(allOptions);
    }
  };

  return (
    <Wrapper>
      <OptionWrapper>
        <Option onClick={toggleAll}>
          {isSelectedAllOptions ? (
            <img src="/assets/images/check/circle-checked-blue.svg" alt="" />
          ) : (
            <img src="/assets/images/check/circle-checked-gray.svg" alt="" />
          )}
          전체
        </Option>

        {categoryGroups.map(({ label, options }) => {
          const allSelected = options.every((item) =>
            selectedItems.includes(item.name),
          );

          return (
            <Group key={label}>
              <GroupTitle onClick={() => toggleGroup(label)}>
                {label}
                {expandedGroups.includes(label) ? (
                  <img
                    src="/assets/images/arrow/black_arrow_up_20.svg"
                    alt=""
                  />
                ) : (
                  <img
                    src="/assets/images/arrow/black_arrow_down_20.svg"
                    alt=""
                  />
                )}
              </GroupTitle>

              {expandedGroups.includes(label) && (
                <>
                  {/* 그룹 전체 선택 */}
                  <Option
                    onClick={() => {
                      if (allSelected) {
                        setSelectedItems((prev) =>
                          prev.filter(
                            (item) =>
                              !options.map((d) => d.name).includes(item),
                          ),
                        );
                      } else {
                        setSelectedItems((prev) =>
                          Array.from(
                            new Set([...prev, ...options.map((d) => d.name)]),
                          ),
                        );
                      }
                    }}
                  >
                    <img
                      src={`/assets/images/check/${allSelected ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt=""
                    />
                    {label} 전체
                  </Option>

                  {/* 개별 항목 */}
                  {options.map((option: { name: string; value: string }) => (
                    <Option
                      key={option.value}
                      onClick={() => toggleItem(option.name)}
                    >
                      <img
                        src={`/assets/images/check/${selectedItems.includes(option.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                        alt=""
                      />
                      {option.name}
                    </Option>
                  ))}
                </>
              )}
            </Group>
          );
        })}
      </OptionWrapper>
      <Bottom>
        <SelectedChipBox>
          {selectedItems.map((item) => (
            <SelectedChip>
              {item}
              <img
                src="/assets/images/close/close-gray.svg"
                alt=""
                onClick={() => toggleItem(item)}
              />
            </SelectedChip>
          ))}
        </SelectedChipBox>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default TotalCategoryOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OptionWrapper = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
`;

const Option = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: center;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const GroupTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 0;

  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;
